import styled from 'styled-components';
import warningSign from '../../../images/warning-sign.svg';

const Container = styled.div`
  display: flex;
  justify-content: center;
`;

const Error = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 2rem;
  border: 0.2rem solid grey;
  border-radius: 0.5rem;
  color: red;
`;

const WarningIcon = styled.img`
  height: 4rem;
  padding-bottom: 1rem;
`;

const ErrorView = ({ error }) => (
  <Container>
    <Error>
      <WarningIcon height={30} src={warningSign} alt="Error" />
      {`Error - ${error}`}
    </Error>
  </Container>
);

export default ErrorView;
